class PreventEmptyHashLinks {
    constructor() {
        document.addEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
        if (!(event.target instanceof Element)) {
            return;
        }

        const link = event.target.closest('a[href]');

        if (!link || link.getAttribute('href')?.trim() !== '#') {
            return;
        }

        event.preventDefault();
    };
}

export { PreventEmptyHashLinks as default };
